import { EcommerceResponse, IEcommerceQuestionSchema } from '../../types'
import style from './PromoRow.module.scss'
import itemStyle from './ItemPreview.module.scss'
import ItemPreview from './ItemPreview'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import { getMediumAssetPath } from '@aytm/lib/common/assets'

const PromoRow = ({
  schema,
  response,
  mainWidth,
  onProductAction,
  onSpin,
  onItemSelect,
  saveScrollPoint
}: {
  schema: IEcommerceQuestionSchema
  response: EcommerceResponse
  mainWidth: number
  onProductAction: (qnt: -1 | 1, index: string, subscribe?: number) => void
  onSpin: (event: React.KeyboardEvent, index: string, subscribe?: number) => void
  onItemSelect: (index: number, bannerPlacement?: string) => void
  saveScrollPoint: (event: React.MouseEvent) => void
}) => {
  const promoAnswers = schema.answers.filter(answer => answer.banner)
  if (promoAnswers.length === 0) return null
  const viewport = useViewport()

  return (
    <>
      <div className={style.header}>
        {schema.ad_image1 && (
          <>
            <img src={getMediumAssetPath(schema.ad_image1)} className={style.logo} />
            <div className={style.divider} />
          </>
        )}
        <div className={style.title}>
          {schema.ad_company_title}
          <div className={style.description}>{schema.ad_company_description}</div>
        </div>
      </div>
      <div className={`${style.content} ${viewport.mobile ? style.mobile : ''}`}>
        {viewport.mobile && schema.ad_image2 && (
          <img src={getMediumAssetPath(schema.ad_image2)} className={style.adImage} />
        )}
        <div className={style.promoRow}>
          {schema.ad_image2 && !viewport.mobile && (
            <img src={getMediumAssetPath(schema.ad_image2)} className={style.adImage} />
          )}
          <div className={style.promoRowItems}>
            {promoAnswers.slice(0, 4).map(answer => (
              <ItemPreview
                schema={answer}
                questionSchema={schema}
                width={
                  (mainWidth - (Math.min(promoAnswers.length, 4) - 1) * 20 - (schema.ad_image2 ? 385 : 0) - 16) /
                  Math.min(promoAnswers.length, 4)
                }
                response={response.answers.find(a => a.id === answer.id)}
                onProductAction={qnt => onProductAction(qnt, answer.id)}
                onSpin={event => onSpin(event, answer.id)}
                onItemSelect={() => onItemSelect(answer.index, 'banner')}
                saveScrollPoint={saveScrollPoint}
                key={answer.id}
                className={`${itemStyle.promo} ${style.promoRowItem}`}
                bannerPlacement="banner"
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default PromoRow
